import React from "react";
import AudioPlayer from "./AudioPlayer";
import FileLink from "./FileLink";

/**
 * MessageAttachments — render any attachments on a DM bubble.
 * Voice/audio → wavesurfer player; video → HTML5 video; image → thumbnail; file → FileLink.
 * Kept compact for chat bubbles (single column).
 */
export default function MessageAttachments({ attachments = [], mine = false }) {
  if (!attachments || attachments.length === 0) return null;
  return (
    <div className="space-y-2">
      {attachments.map((a) => {
        if (a.kind === "voice" || a.kind === "audio") {
          return <AudioPlayer key={a.url} src={a.url} name={a.name || "Audio"} />;
        }
        if (a.kind === "video") {
          return (
            <div
              key={a.url}
              className="bg-black border border-white/5 rounded-xl overflow-hidden"
              data-testid="dm-video-attachment"
            >
              <video
                src={a.url}
                controls
                preload="metadata"
                className="w-full max-h-[360px] bg-black"
              >
                Your browser does not support video.
              </video>
              {a.name && (
                <div className={`text-xs px-3 py-2 truncate ${mine ? "text-navy/70 bg-paul-yellow/30" : "text-white/60"}`}>
                  {a.name}
                </div>
              )}
            </div>
          );
        }
        if (a.kind === "image") {
          return (
            <a
              key={a.url}
              href={a.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block rounded-xl overflow-hidden border border-white/5 max-w-[280px]"
              data-testid="dm-image-attachment"
            >
              <img
                src={a.url}
                alt={a.name || "Attachment"}
                className="w-full max-h-[280px] object-cover"
                loading="lazy"
              />
            </a>
          );
        }
        return <FileLink key={a.url} src={a.url} name={a.name} size={a.size} />;
      })}
    </div>
  );
}
